<template>
  <div class="accordion">

    <!-- Accordion Collapse -->
    <div v-if="accordionType === 'collapse'">
      <div class="header">
        <a href="#" @click.prevent="toggle()">
          <span v-dompurify-html="label"></span>

          <b-icon class="arrow" :class="{ 'collapsed': active }" icon="chevron-down"></b-icon>
        </a>
      </div>

      <div class="content collapsible" :class="{ 'collapsed': active }">
        <div class="content-inner">
          <slot />
        </div>
      </div>
    </div>

    <!-- Accordion link-->
    <div v-if="accordionType === 'link'">
      <div class="header">
        <a :href="getRoutePath(routeName)" v-on:click.prevent="onNavItemClick(routeName)">
          {{ label }}

          <b-icon class="arrow" icon="chevron-right"></b-icon>
        </a>
      </div>
    </div>

  </div>
</template>

<script>
    import { BIcon } from 'bootstrap-vue'
    import {mixinRoutesHandler} from '@/mixins/routes-handler';

    export default {
    name: 'Accordion',

    mixins: [mixinRoutesHandler],

    props: {
        label: String,
        accordionType: {
            type: String,
            default: 'collapse'
        },
        url: String,
        routeName: String,
    },

    components: {
        BIcon,
    },

    data() {
        return {
            active: false,
            toggleLocked: true,
        }
    },

    methods: {
        collapseLogic() {
            let x = window.innerWidth;

            if (x < 991) {
                this.active = false;
                this.toggleLocked = false;
                return;
            }

            this.active = true;
            this.toggleLocked = true;
        },

        /* Actions */
        toggle() {
          if (!this.toggleLocked) {
            this.active = !this.active;
          }
        },

        getRoutePath(routeName) {
            return this._mixinGetRoutePath(routeName);
        },

        /* Events */
        onNavItemClick(routeName) {
            this._mixinGoToRouteName(routeName);
        },

        onWindowResize() {
            this.collapseLogic();
        },

        onSpawn() {
            this.collapseLogic();
        },
    },

    created() {
        window.addEventListener("resize", this.onWindowResize);
    },

    destroyed() {
        window.removeEventListener("resize", this.onWindowResize);
    },

    mounted: function () {
        this.$nextTick(function () {
            this.onSpawn();
        });
    },

    watch: {
      '$route': function () {
        if (!this.toggleLocked) {
          this.active = false;
        }
      },
    },
}
</script>

<style scoped lang="scss">
  .accordion {

    img {
      width: 24px;

      &:hover, &:focus, &:active, &:visited {
        opacity: 0.7;
      }
    }

    .header {
      padding: 0 8px;

      a {
        width: 100%;
        padding: 20px 0;
        //border-bottom: 1px solid #999;
        border-bottom: 1px solid #cecece;
        //color: #999;
        color: #cdcccc;
        font-weight: normal;

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        &:hover, &:focus, &:active, &:visited {
          text-decoration: none;
        }
      }

      .arrow {
        -webkit-transition: -webkit-transform .4s ease-in-out;
        -ms-transition: -ms-transform .4s ease-in-out;
        transition: transform .4s ease-in-out;

        &.collapsed {
          transform:rotate(180deg);
          -ms-transform:rotate(180deg);
          -webkit-transform:rotate(180deg);
        }
      }
    }

    .content {
      color: #cdcccc;

      &.collapsible {
        overflow: hidden;
        max-height: 0;
        transition: max-height 0.25s ease-out;

        &.collapsed {
          max-height: 1150px;
          transition: max-height 0.25s ease-in;
        }

        .content-inner {
          padding: 16px 8px 0 8px;
        }
      }

      a {
        font-size: 15px !important;
        color: #cdcccc;
      }

      ul {
        list-style: none;
        padding-left: 0;
        margin-bottom: 0;

        li {
          padding-bottom: 10px;

          ul {
            padding-left: 8px;
          }
        }
      }
    }

    @media (min-width: $lgBreakpoint) {
      .header {
        a {
          border-bottom: none;
          cursor: text;
          padding: 0;

          &:hover {
            text-decoration: none;
          }
        }

        .arrow {
          display: none;
        }
      }

      .content {
        padding: 0 8px;
      }
    }
  }
</style>
